import type {
  ParcelAPNParams,
  ParcelAPNsParams,
  ParcelPointParams,
} from '~/postgres.server'
import { loader as ParcelAPNLoader } from '~/routes/api.parcels.apn/route'
import { loader as ParcelAPNsLoader } from '~/routes/api.parcels.apns/route'
import { loader as ParcelPointLoader } from '~/routes/api.parcels.point/route'
import { paramsToQuery } from './utils'

export async function getParcelsByAPNs(params: ParcelAPNsParams) {
  const response = await fetch(`/api/parcels/apns${paramsToQuery(params)}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })

  if (!response.ok || response.bodyUsed) {
    throw new Error(
      `Error fetching parcels: ${response.status} ${response.statusText}`
    )
  }

  const data = (await response.json()) as Awaited<
    ReturnType<typeof ParcelAPNsLoader>
  >

  if ('parcels' in data) {
    return data
  } else {
    throw new Error(`Error fetching parcels: invalid response data`)
  }
}

async function getParcelsByAPN(params: ParcelAPNParams) {
  const response = await fetch(`/api/parcels/apn${paramsToQuery(params)}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })

  if (!response.ok || response.bodyUsed) {
    throw new Error(
      `Error fetching parcel: ${response.status} ${response.statusText}`
    )
  }

  const data = (await response.json()) as Awaited<
    ReturnType<typeof ParcelAPNLoader>
  >

  if ('parcels' in data) {
    return data
  } else {
    throw new Error(`Error fetching parcel: invalid response data`)
  }
}

async function getParcelsByPoint(params: ParcelPointParams) {
  const response = await fetch(`/api/parcels/point${paramsToQuery(params)}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })

  if (!response.ok || response.bodyUsed) {
    throw new Error(
      `Error fetching parcel: ${response.status} ${response.statusText}`
    )
  }

  const data = (await response.json()) as Awaited<
    ReturnType<typeof ParcelPointLoader>
  >

  if ('parcels' in data) {
    return data
  } else {
    throw new Error(`Error fetching parcel: invalid response data`)
  }
}

export async function getParcel(parcelApn: string, path: string) {
  const response = await getParcelsByAPN({
    parcelnumb: parcelApn,
    path,
  })

  return response.parcels.features[0]
}

export async function getParcels(parcelApn: string, path: string) {
  const response = await getParcelsByAPN({
    parcelnumb: parcelApn,
    path,
  })

  return response.parcels.features
}

export async function searchParcels(
  latitude: string | number,
  longitude: string | number,
  limit?: number
) {
  const lat = +latitude
  const lon = +longitude
  const response = await getParcelsByPoint({ lat, lon, limit })

  response.parcels.features.sort((a, b) => {
    // Only care about comparing if there are units
    return (
      parseInt(a.properties.fields.sunit ?? '0') -
      parseInt(b.properties.fields.sunit ?? '0')
    )
  })

  return response.parcels
}
